import type { LeagueCategoryFilter } from '@/services/game';
import { useAllLeagueCategoriesQuery } from '@/services/league-category';

// Categories are preloaded by the authenticated layout and returned primary-first
const useDefaultLeagueCategory = (): LeagueCategoryFilter => {
  const categoriesQuery = useAllLeagueCategoriesQuery();
  const firstPrimary = categoriesQuery.data?.find((item) => item.is_primary);

  return firstPrimary ? `${firstPrimary.id}` : 'none';
};

export default useDefaultLeagueCategory;
